module.exports = __webpack_public_path__ + "static/google-zoom-535da951e2399b6b8743ce583a4d35a8.gif";